import styles from 'styles/modules/Divider.module.scss';

const Divider = (props) => {
    return <div className={styles.divider} {...props} />;
};

export default Divider;
